declare global {
  interface Window {
    Rollbar: any;
  }
}

export const Rollbar = window.Rollbar || { 'error': () => {} };
